import React from "react";
import "./Integrations.css";
import { useLanguage } from "../../context/LanguageContext";

// 1. IMPORT DES LOGOS (À décommenter et ajuster selon tes vrais fichiers)
import skaleLogo from "../../assets/Skale.png";
import vivenuLogo from "../../assets/vivenu.png";
import spaLogo from "../../assets/Spa1.png";
import acefundLogo from "../../assets/acefund.png";

const Integrations = () => {
  const { t } = useLanguage();

  // 2. TABLEAU DES PARTENAIRES
  // Remplace les chaînes de caractères temporaires par tes variables d'import (ex: logo: skaleLogo)
  const partners = [
    { name: "Skale", logo: skaleLogo },
    { name: "Vivenu", logo: vivenuLogo },
    { name: "Spa", logo: spaLogo },
    { name: "Acefund", logo: acefundLogo },
  ];

  return (
    <section className="integrations-section">
      <div className="integrations-overlay">
        {/* On utilise la traduction pour rester propre */}
        <p>{t.integrations.title}</p>
      </div>

      <div className="marquee-wrapper">
        <div className="marquee-content">
          {partners.map((partner, index) => (
            <div key={`first-${index}`} className="partner-item">
              <img
                src={partner.logo}
                alt={`Logo partenaire ${partner.name}`}
                className="partner-logo"
                loading="lazy"
              />
            </div>
          ))}
        </div>

        {/* On double le contenu pour l'illusion d'infini */}
        <div className="marquee-content" aria-hidden="true">
          {partners.map((partner, index) => (
            <div key={`second-${index}`} className="partner-item">
              <img
                src={partner.logo}
                alt={`Logo partenaire ${partner.name}`}
                className="partner-logo"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Integrations;
